<hr />
<div class="zas-row short-row">
    <table class="table-with-spacing">
        <tr>
            <td>
                <zbd-validity-indicator
                    [validity]="validity"
                ></zbd-validity-indicator>
            </td>
            <td width="100%">
                Ich möchte
                <span class="section-title">{{ section.CategoryName }}</span>
            </td>
            <td>
                <span
                    class="zas-header-icon icon-close-tag"
                    (click)="deleteSection.next(section)"
                ></span>
            </td>
        </tr>
    </table>
</div>
<div class="zas-row right-padded-row">
    <table class="table-with-spacing">
        <tr>
            <th width="5%"></th>
            <th width="50%"></th>
            <th width="15%">
                Priorität
                <zbd-info class="info">
                    Priorität:<br />
                    1 = sehr wichtig,<br />
                    5 = nicht wichtig
                </zbd-info>
            </th>
            <th width="15%">Beratung gewünscht</th>
            <th width="15%">Folgetermin</th>
        </tr>

        <!-- START: Global occasion entries -->
        <tr
            *ngFor="
                let entry of section.GlobalOccasionEntries;
                trackBy: trackEntity
            "
        >
            <td>
                <zbd-validity-indicator
                    [validity]="validity.entries[entry.Id]"
                ></zbd-validity-indicator>
            </td>
            <td>
                {{ entry.Topic }}
            </td>
            <td>
                <zbd-input
                    type="select"
                    name="priority"
                    [entity]="entry"
                    property="Priority"
                    [updateFn]="updatePriority()"
                >
                    <option [value]="" disabled></option>
                    <option [value]="1">1</option>
                    <option [value]="2">2</option>
                    <option [value]="3">3</option>
                    <option [value]="4">4</option>
                    <option [value]="5">5</option>
                </zbd-input>
            </td>
            <td>
                <zbd-input
                    type="select"
                    name="consultingRequested"
                    [entity]="entry"
                    property="ConsultingRequested"
                    [updateFn]="updateConsultingRequested()"
                >
                    <option [value]="" disabled="true"></option>
                    <option [value]="true">Ja</option>
                    <option [value]="false">Nein</option>
                </zbd-input>
            </td>
            <td>
                <zbd-input
                    type="date"
                    name="remark"
                    [entity]="entry"
                    property="ConsultingDate"
                    [updateFn]="persistence.updateGlobalOccasionEntry"
                ></zbd-input>
            </td>
        </tr>
        <!-- END: Global occasion entries -->

        <tr>
            <td></td>
            <td>Bemerkung</td>
            <td colspan="3">
                <zbd-input
                    type="text"
                    name="remark"
                    [entity]="section"
                    property="Remark"
                    [updateFn]="persistence.updateGlobalOccasionSection"
                ></zbd-input>
            </td>
        </tr>
    </table>
</div>
